module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("For my daughters, Ava and Aila, and for all the women who seem to have it together and all the women who think they don’t have it together.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("For my Love, it took me a long time to truly understand what it means to appreciate and love unconditionally. Growing up, you get screwed over with the notion that Disney infiltrates our expectations. You look for the knight in shining armour. You wait for the leg-popping first kiss and the real fuckery of the idealistic happily ever after. As cliché as it sounds, the fact is that love is a journey. From adolescence through parenthood, your understanding of love evolves and grows as you mature. I have been so blessed to be married to my best friend. He drives me batty and is occasionally a pain in the ass. But he is my world. He has my complete heart, and he is the absolute love of my life. My goal for the rest of our days together in this life is to dedicate my love to building our life together—loving each other wholeheartedly, forever. Through the challenges and shitty situations, I’m going to love him through the highest of highs and the lowest of lows.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0